// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_1q-7";
export var adjustableWidthBorderHeld = "_1q-8";
export var arrow = "_1q-3";
export var arrowButton = "_1q-4";
export var headerCell = "_1q-0";
export var help = "_1q-2";
export var icon = "_1q-1";
export var iconWrapper = "_1q-6";
export var noBorder = "_1q-b";
export var nonAdjustableWidthBorder = "_1q-9";
export var nonAdjustableWidthBorderHeld = "_1q-a";
export var textButton = "_1q-5";